export const WINDOW_QUERY = Object.freeze({
  medium: "(min-width: 600px)",
  expanded: "(min-width: 840px)",
  large: "(min-width: 1200px)",
  "extra-large": "(min-width: 1600px)",
});
